<template>
    <div>
        <section class="q10__jumbotron">
            <image-with-descriptions
                class="mb-8 mt-0"
                :options="{
                    image:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.oImage1.src,
                    descriptions: [
                        {
                            text: currentPage.images.oImage1.edf,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                    ],
                }"
            />
            <div class="relative z-0">
                <hotspot-richmedia
                    :options="{
                        icon: 'diaporama',
                        collection: getRichmediaByCollection(
                            currentPage,
                            'L’ingénierie hydraulique, championne de la flexibilité'
                        ),
                    }"
                    class="bottom-10 left-2"
                />
            </div>
        </section>
        <div class="page">
            <div class="container px-11 2xl:px-3 mb-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-selective_green',
                        to: 'to-golden_sand',
                    }"
                >
                    <h1 v-html="currentPage.content.sArticleTitle.alt"></h1>
                    <h3
                        class="text-xl lg:text-2xl 2xl:text-4xl"
                        v-html="currentPage.content.sArticleTitle.title"
                    ></h3>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-xl mb-5"
                    v-html="currentPage.content.sArticleDescription.text"
                ></p>

                <div class="container-components">
                    <div class="card" style="padding: 0">
                        <div class="relative">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        `Fonctionnement d’une STEP`
                                    ),
                                }"
                                class="-top-4 right-2"
                            />
                            <!-- <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            `STEP `
                                        ),
                                    }"
                                    class="-top-4 right-2"
                                /> -->
                        </div>
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-sushi',
                            }"
                        >
                            <p
                                v-html="
                                    currentPage.content.sParagraphOne_Title.text
                                "
                            ></p>
                        </TitleParagraph>
                        <span
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphOne_Content_01
                                    .text
                            "
                        ></span>
                        <router-link
                            :to="{
                                name: 'catalogue',
                                params: { slug: 'page-015' },
                            }"
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphOne_Content_03
                                    .text
                            "
                        ></router-link>
                        <span
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphOne_Content_02
                                    .text
                            "
                        >
                        </span>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-sushi',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphTwo_Title.text
                                "
                            ></span>
                        </TitleParagraph>
                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphTwo_Content.text
                            "
                        ></p>
                    </div>
                    <div class="card" style="padding: 0">
                        <div class="break-inside-avoid">
                            <div class="relative">
                                <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            `XFLEX HYDRO : démonstrateur de Vogelgrun`
                                        ),
                                    }"
                                    class="top-2 right-2"
                                />
                            </div>
                            <image-with-descriptions
                                class="eliminate-margin"
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage2.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage2
                                                .alt,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: currentPage.images.oImage2
                                                .text,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                    fontSize: 'text-xs',
                                }"
                            />
                            <TitleParagraph
                                :options="{
                                    from: 'from-selective_green',
                                    to: 'to-golden_sand',
                                }"
                            >
                                <Triangles
                                    :options="{
                                        colors: [
                                            '#81C341',
                                            '#B7DD92',
                                            '#cce5a4',
                                        ],
                                        direction: 'top',
                                    }"
                                />
                                <span
                                    v-html="
                                        currentPage.content
                                            .sParagraphThree_Title.text
                                    "
                                ></span>
                            </TitleParagraph>
                        </div>

                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphThree_Content.text
                            "
                        ></p>
                    </div>
                    <div class="card">
                        <div class="relative mt-4">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        `SoFLEX’hy : expériences sur la Durance`
                                    ),
                                }"
                                class="-top-6 right-2 md:top-2 md:-mr-8 lg:mr-0 lg:-top-5 xl:-top-6"
                            />
                        </div>
                        <div class="relative mt-4">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        `SoFLEX’hy: présentation`
                                    ),
                                }"
                                class="-top-6 right-16 md:top-2 md:-mr-8 lg:mr-0 lg:-top-5 xl:-top-6"
                            />
                        </div>
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphFour_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>

                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                class="text-nandor 2xl:text-lg"
                                v-html="
                                    currentPage.content.sParagraphFour_Content
                                        .text
                                "
                            ></span>
                        </paragraph>
                    </div>
                    <div class="card" style="padding-top: 0">
                        <article-note
                            class="eliminate-margin"
                            :options="{
                                verticalcontent:
                                    currentPage.content.sParagraphFive_Title
                                        .text,
                                content:
                                    currentPage.content.sParagraphFive_Content
                                        .text,
                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    verticalcontent: 'text-2xl 2xl:text-3xl',
                                    content: '',
                                },
                            }"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
    },
    name: "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
</style>
